export default {
  AUTHENTICATION_ROUTE: '/',
  UPLOAD_DOCUMENTS_ROUTE: '/documents',
  UPLOAD_FIELDS_ROUTE: '/fields',
  FINISH_ROUTE: '/finish',
  LIVENESS_ROUTE: '/liveness',
};
